import { Component, OnInit, NgZone, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { QuestionServiceService } from '../../../../../../services/question-service.service';
import { FeeColumnFilterPanelService } from '../../../../../../services/fee-column-filter-panel.service';
import { StorageUtil } from '../../../../../../store';

@Component({
  selector: 'app-tryout-add-standard',
  templateUrl: './tryout-add-standard.component.html',
  styleUrls: ['./tryout-add-standard.component.css']
})
export class TryoutAddStandardComponent implements OnInit {
  @Output() getQuestionsEvent = new EventEmitter();
  @Output() closeSideOverlayEvent = new EventEmitter();
  public originalQuestionsList: any;
  public QuestionsList: any;
  public preSetQuestionForm: FormGroup;
  public routeParams;
  public is_show_visible_column_panel: boolean;
  public StandardQuestions?= [];
  public CustomQuestions?= [];

  constructor(private fb: FormBuilder,
    private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private questionService: QuestionServiceService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {
    this.is_show_visible_column_panel = false;
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;
    this.preSetQuestionForm = this.fb.group({
      Questions: this.fb.array([])
    });
    this.getPreSetQuestion();
  }

  getQuestions(status) {
    this.spinnerService.show();
    this.questionService.getQuestions(this.routeParams.id, status).subscribe(rs => {
      this.StandardQuestions = rs.standardQuestionList ? rs.standardQuestionList.filter(x => !x.isParent) : rs.standardQuestionList;
    });
    this.spinnerService.hide();
  }

  getPreSetQuestion() {
    this.spinnerService.show();
    this.questionService.getpreSetQuestions(this.routeParams.id).subscribe(rs => {
      this.originalQuestionsList = rs;
      this.QuestionsList = rs.filter(x => !x.isParent);
      this.patch();
    });
    this.spinnerService.hide();
  }

  postStandardQuestion(postModel) { }

  patch() {
    const control = <FormArray>this.preSetQuestionForm.get('Questions');
    this.QuestionsList.forEach(x => {
      control.push(this.fb.group({
        QuestionChecked: x.isUsed,
        QuestionId: [x.clubProgramPreSetQuestionID],
        questionText: [x.questionText],
        Answer: ((x.isUsed) ? (x.isRequired ? "Yes" : "No") : ""),
        clubProgramQuestionTypeID: x.clubProgramQuestionTypeID,
        //isrequired: [x.isrequired]
      }));
    });
  }

  /* Save preset questions. */
  onSave(event, status) {
    event.stopPropagation();
    var postModel = [];
    var _Questions = this.preSetQuestionForm.value.Questions;
    for (var i = 0; i < _Questions.length; i++) {
      var _que = _Questions[i];
      if (_que.QuestionChecked === true) {
        postModel.push({
          clubprogramID: this.routeParams.id,
          clubprogramquestionID: _que.QuestionId,
          label: _que.questionText,
          isrequired: _que.Answer === "Yes" ? 1 : 0,
          clubprogramquestiontypeID: _que.clubProgramQuestionTypeID,
          addedby: StorageUtil.userID,
          inuse: true
        });
      }
    }
    const obj = {
      "standardQuestionList": postModel
    };
    event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;
    this.questionService.postStandardQuestions(obj).subscribe(rs => {
      event.target.innerHTML = 'Save';
      event.target.disabled = false;
      this.getPreSetQuestion();
      this.refreshReocrds();
      this.closeSideOverlayEvent.emit();
    });
  }

  onCancel() {
    this.closeSideOverlay();
  }

  onChangeQuestion(event, index) {
    var ctrls = this.preSetQuestionForm['controls']['Questions']['controls'][index]['controls'];
    if (event.target.checked) {
      if (ctrls["Answer"] !== "No") {
        ctrls['Answer'].patchValue("Yes");
      }
    } else {
      ctrls['Answer'].patchValue("");
    }
  }

  onChangeAnswer(event, index) {
    var ctrls = this.preSetQuestionForm['controls']['Questions']['controls'][index]['controls'];
    if (event.target.checked) {
      ctrls['QuestionChecked'].patchValue(true);
    }
  }

  openSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(true);
  }

  closeSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }

  toggleSideOverlay() {
    if (this.is_show_visible_column_panel) {
      this.is_show_visible_column_panel = false;
    } else {
      this.is_show_visible_column_panel = true;
    }
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(this.is_show_visible_column_panel);
  }

  clearFormData() {
    this.preSetQuestionForm.reset();
  }

  refreshReocrds() {
    this.getQuestionsEvent.emit({ IsRequired: 0 });
  }

}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-questions/tryout-read-questions/partial/tryout-add-standard/tryout-add-standard.component.ts